export default "__VITE_ASSET__fY9Z0oL___"